import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import { hooks } from 'lib.front';
const { useCsv } = hooks;

const data = [
   {
      nombre: 'jesus',
      edad: 23,
      otros: 'asdfasdf'
   },
   {
      nombre: 'jose',
      edad: 35,
      otros: '464565431'
   },
   {
      nombre: 'javier',
      edad: 18,
      otros: 'askldfj'
   },
   {
      nombre: 'maria',
      edad: 23,
      otros: 'lñjkn'
   }
];
function PruebaComponentes() {
   const [exportar, { procesando, filaActual }] = useCsv();
   function callbackProcesarData(data) {
      console.log(data);
   }

   function onClickSubir() {
      exportar(data, { descargarAlFinalizar: true });
   }
   return (
      <Container>
         <Grid container spacing={2} style={{ marginTop: '10px' }}>
            <Grid item xs={12}>
               Cargando={procesando.toString()}
            </Grid>
            <Grid item xs={12}>
               nroFila={filaActual}
            </Grid>
            <Grid item xs={12}>
               <Button onClick={onClickSubir}>Procesar</Button>
            </Grid>
         </Grid>
      </Container>
   );
}

export default PruebaComponentes;
